export const removeUuidPrefix = (str) => {
    if (typeof str !== 'string') {
        console.warn("removeUuidPrefix: 'str' must be a string");
        return str;
    }

    // Match a UUID (v4 style) at the start of the string, optionally followed by a space
    return str.replace(
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}\s*/,
        ''
    );
};
